import { variant } from 'styled-system';

const size = () =>
  variant({
    prop: 'size',
    variants: {
      small: {
        width: '20%',
      },
      medium: {
        width: '60%',
      },
      large: {
        width: '100%',
      },
    },
  });

export default size;
